import { useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { commercialsApi } from "../api/commercials";
import { formatCurrency } from "../../../shared/utils";

export const useBudget = (projectId: string | undefined) => {

    const theme = useTheme();

    const limit = 200;
    const page = 1;

    const colorPalette = [
        theme.palette.primary.main,
        theme.palette.secondary.main,
        theme.palette.info.main,
        theme.palette.success.main,
        theme.palette.warning.main,
        theme.palette.error.main,
    ];

    const getRandomColor = (index: number) => {
        return colorPalette[index % colorPalette.length];
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-budget", projectId, limit, page],
        queryFn: () => commercialsApi.fetchBudgets({ projectId, limit, page}),
    });

    return {
        data: data?.data?.rows, isLoading, isError, error,
        chartData:
            data?.data?.rows
                .filter((v: { parent_id: number | null }) => v.parent_id === null)
                .map((v: { name: string; baseline: number }, index: number) => ({
                    label: v.name,
                    value: Number(v.baseline),
                    color: getRandomColor(index),
                    legendValue: formatCurrency(Number(v.baseline)),
                    legendLabel: v.name.concat(" ", formatCurrency(Number(v.baseline))),
                })) || []
    };

};